import { Component, OnInit, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { TranslatePipeModule } from '../../shared/translate.pipe';
import { CommonModule } from '@angular/common';
import { OeAppService } from '../../shared/oe-app.service';

@Component({
  selector: 'lp2-b2b-group-classes-banner',
  templateUrl: './b2b-group-classes-banner.component.html',
  styleUrls: ['./b2b-group-classes-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'container'
  }
})
export class B2bGroupClassesBannerComponent {
  public readonly BANNER_IMAGE = '../../../../images/b2b-group-classes/b2b-group-classes-banner.jpg';

  constructor(private readonly oeAppPersonService: OeAppPersonService, private readonly oeAppService: OeAppService) { }

  public get companyName() {
    return this.oeAppPersonService.companyName;
  }

  public get companyUuid() {
    return this.oeAppPersonService.companyUuid;
  }

  public get companyLogo() {
    return `https://${this.oeAppService.s3BucketHost()}/b2b/logos/${this.companyUuid}.png`;
  }
}

@NgModule({
  imports: [CommonModule, TranslatePipeModule],
  declarations: [B2bGroupClassesBannerComponent],
  exports: [B2bGroupClassesBannerComponent],
})
export class B2bGroupClassesBannerModule {}


// WEBPACK FOOTER //
// ./ts/app/components/b2b-group-classes-banner/b2b-group-classes-banner.component.ts